import React from 'react';
import MainLayout from '../components/Layout/MainLayout';
import DashboardHome from '../components/Dashboard/DashboardHome';

const DashboardPage = () => (
  <MainLayout><DashboardHome /></MainLayout>
);


export default DashboardPage;